import { ResourceGuard } from './../auth/guards/resource.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BulkMessagesComponent } from './bulk-messages/bulk-messages.component';
import { DocLibraryComponent } from './doc-library/doc-library.component';
import { AllMyTasksComponent } from './my-tasks/all-my-tasks/all-my-tasks.component';
import { BankPaymentsComponent } from './bank-payments/bank-payments.component';
import { BanksComponent } from './bank-payments/banks/banks.component';
import { ViewMyTasksComponent } from './my-tasks/view-my-task/view-my-tasks.component';
import { FacebookComponent } from '../shared/components/integration/facebook/facebook.component';
import { SocialFeedComponent } from '../shared/components/social-feed/social-feed.component';
import { ModuleGuard } from '../auth/guards/module.guard';
import { BankGuard } from '../auth/guards/bank.guard';

const routes: Routes = [
  {
    path: 'all-my-tasks',  component: AllMyTasksComponent,
    data: {module: 'TASKS'}, canActivate: [ ModuleGuard ]
  },
  {
    path: 'view-my-tasks/:id', component: ViewMyTasksComponent,
    data: {module: 'TASKS'}, canActivate: [ ModuleGuard ]
  },
  { 
    path: 'banks', component: BanksComponent, 
    data: {resource: 'BANK_PAYMENT'}, canActivate: [ BankGuard ] },
  { 
    path: 'banks/:id', component: BankPaymentsComponent,
    data: {resource: 'BANK_PAYMENT'}, canActivate: [ BankGuard ]
  },
  { path: 'bulk-messages', component: BulkMessagesComponent },
  { path: 'doc-library', component: DocLibraryComponent },
  {
    path: 'facebook', component: FacebookComponent,
    data: {resource: 'SOCIAL_MONITORING_2'}, canActivate: [ ResourceGuard ]
  },
  {
    path: 'social-feed', component: SocialFeedComponent,
    data: {resource: 'SOCIAL_MONITORING_2'}, canActivate: [ ResourceGuard ]
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class MiscRoutingModule { }
